import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    form: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(-1),
      width: '576px',
    },

    input: {
      marginBottom: theme.spacing(1),
    },
    alert: {
      padding: '16px',
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      '& .MuiAlert-icon': {
        fontSize: '16px',
        paddingTop: '4px',
      },
      '& .MuiAlert-message': {
        padding: '0px',
        color: '#000000',
      },
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: '#000000',
    },
    warning: {
      padding: '16px',
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      '& .MuiAlert-icon': {
        fontSize: '20px',
      },
      '& .MuiAlert-message': {
        color: '#424242',
      },
    },
  }),
);
